// Animation constants
const PULSE_DELAY_MAX_SECONDS = 0.1;
const PULSE_DELAY_DECIMAL_PLACES = 3;
const PULSE_ANIMATION_DURATION_SECONDS = 0.75;

/**
 * Generates a random pulse delay for animation effects
 * @returns {string} Delay value in seconds (e.g., "0.123s")
 */
export const generatePulseDelay = () => {
    const delay = (Math.random() * PULSE_DELAY_MAX_SECONDS).toFixed(PULSE_DELAY_DECIMAL_PLACES);
    return `${delay}s`;
};

/**
 * Calculates the total time needed for the pulse animation to complete
 * (delay + duration) in milliseconds
 * @returns {number} Total animation time in milliseconds
 */
export const getPulseAnimationTotalTime = () => {
    return (PULSE_DELAY_MAX_SECONDS + PULSE_ANIMATION_DURATION_SECONDS) * 1000;
};

// Export constants for direct access if needed
export const ANIMATION_CONSTANTS = {
    PULSE_DELAY_MAX_SECONDS,
    PULSE_DELAY_DECIMAL_PLACES,
    PULSE_ANIMATION_DURATION_SECONDS
};

